(function() {
  'use strict';

  angular
    .module('cfn')
    .directive('cfnTagListReferenceBox', cfnTagListReferenceBox);

  function cfnTagListReferenceBox() {
    var template =
      '<div ' +
      'class="referenceBox">' +
      '   <table class="subElement tagListTable" width="100%">' +
      '       <tr>' +
      '           <td width="100%" style="">' +
      '				<span class="tagList">' +
      '<span ng-repeat="element in arrayModel" ng-click="remove(element)" title="{{element[hoverField]}}">' +
      '{{element[nameField]}} ' +
      '</span> ' +
      '</span>' +
      '           </td>' +
      '           <td><div ng-show="!readonly">' +
      '               <cfn-select-reference class="imgOnly open" multiselect="true" result="result" service-param="{{serviceParam}}" pathExt="{{pathExt}}" title="{{title}}" type="{{type}}" popover-path="{{popoverPath}}">' +
      '                   <img src="img/bicons/black/add.png"/>' +
      '               </cfn-select-reference>' +
      '      </div> </td>' +
      '       </tr>' +
      '   </table>' +
      '</div>';

    return {
      restrict: 'E',
      scope: {
        model: '=',
        nameField: '@',
        hoverField: '@',
        title: '@',
        type: '@',
        popoverPath: '@',
        serviceParam: '@',
        pathExt: '@',
        readonly: '=',
        resultParam: '@'
      },
      template: template,
      link: link
    };

    function link(scope, element, attrs) {
      /*element.click(function(event){
             // if the element is no button in the first place, the element was a click on the background
             if(!($(event.target).is(":button")||$(event.target).parent().is(":button"))){
             ang.callAfter(function(){
             // we need to leave the angular scope because the click triggers an angular scope itself
             element.find(".open button").trigger("click");
             });
             }
             });*/
      scope.arrayModel = [];

      scope.$watch('model', function() {
        if (scope.model) {
          scope.arrayModel = angular.fromJson(scope.model);
        } else {
          scope.arrayModel = [];
        }
      });

      scope.updateModel = function() {
        scope.model = angular.toJson(scope.arrayModel);
      };
      scope.remove = function(ele) {
        if (!scope.readonly) {
          $.arrayRemove(scope.arrayModel, ele);
          scope.updateModel();
        }
      };
      scope.result = function(ob) {
        if (Object.keys(ob).length === 0) {
          scope.arrayModel = [];
        } else {
          var alreadyFound = false;
          for (var k in scope.arrayModel) {
            var o = scope.arrayModel[k];
            if (o.id == ob.id) {
              alreadyFound = true;
            }
          }
          if (!alreadyFound) scope.arrayModel.push(ob);
        }
        scope.updateModel();
      };
    }
  }
})();
